import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { Container, Row, Col, Card } from "react-bootstrap";
import { ExternalLink, Award, Star, CheckCircle } from 'lucide-react';
import fiero from '../../assets/img/logos/fiero.png';
import foset from '../../assets/img/logos/foset.png';
import hermex from '../../assets/img/logos/hermex.png';
import klintek from '../../assets/img/logos/klinteck.png';
import pretul from '../../assets/img/logos/pretul.png';
import truper from '../../assets/img/logos/truper.png';
import volteck from '../../assets/img/logos/volteck.png';
import FlipbookViewer from './Flipbookviewer';

const marcas = [
    {
        id: 1,
        nombre: "TRUPER",
        descripcion: "Herramientas de alto desempeño con más de 60 años de experiencia",
        logo: truper,
        bg: "#F26423",
        color: "#F26423",
        // NUEVO: Configuración para flipbook
        catalogoPath: "/catalogos/truper",  // Ruta a las imágenes
        paginaInicio: 1,                     // Página donde inicia esta marca
        totalPaginas: 372,                   // Total de páginas del catálogo
        pdfUrl: "/catalogos/TruperCatalogo.pdf", // PDF para descarga
        // Mantén tus campos existentes
        destacado: true,
        caracteristicas: ["Calidad Premium", "Líder del mercado"]
    },
    {
        id: 2,
        nombre: "PRETUL",
        descripcion: "Productos caseros diseñados para uso ligero y labores en el hogar",
        logo: pretul,
        bg: "#FECF33",
        color: "#FECF33",
        catalogoPath: "/catalogos/pretul",  // Ruta a las imágenes
        paginaInicio: 5,                     // Página donde inicia esta marca
        totalPaginas: 372,        
        pdfUrl: "/catalogos/PretulCatalogo.pdf", // PDF para descarga
        caracteristicas: ["Uso doméstico", "Precio accesible"]
    },
    {
        id: 3,
        nombre: "FOSET",
        descripcion: "Grifería y plomería con 5 líneas que cubren todas las necesidades",
        logo: foset,
        bg: "#005F9E",
        color: "#005F9E",
        catalogoPath: "/catalogos/foset",  // Ruta a las imágenes
        paginaInicio: 1,                     // Página donde inicia esta marca
        totalPaginas: 81,        
        pdfUrl: "/catalogos/FosetCatalogo.pdf", // PDF para descarga
        caracteristicas: ["5 líneas", "Plomería completa"]
    },
    {
        id: 4,
        nombre: "VOLTECK",
        descripcion: "Productos eléctricos para el mercado ferretero",
        logo: volteck,
        bg: "#2E3192",
        color: "#2E3192",
        catalogoPath: "/catalogos/volteck",  // Ruta a las imágenes
        paginaInicio: 1,                     // Página donde inicia esta marca
        totalPaginas: 78,        
        pdfUrl: "/catalogos/VolteckCatalogo.pdf", // PDF para descarga
        caracteristicas: ["Eléctricos", "Seguridad certificada"]
    },
    {
        id: 5,
        nombre: "FIERO",
        descripcion: "Productos de acero para la industria ferretera",
        logo: fiero,
        bg: "#2D2D2D",
        color: "#2D2D2D",
        catalogoPath: "/catalogos/fiero",  // Ruta a las imágenes
        paginaInicio: 1,                     // Página donde inicia esta marca
        totalPaginas: 28,        
        pdfUrl: "/catalogos/FieroCatalogo.pdf", // PDF para descarga
        caracteristicas: ["Acero resistente", "Uso industrial"]
    },
    {
        id: 6,
        nombre: "HERMEX",
        descripcion: "Cerrajería con la más alta calidad y diseño",
        logo: hermex,
        bg: "#BE1E2D",
        color: "#BE1E2D",
        catalogoPath: "/catalogos/hermex",  // Ruta a las imágenes
        paginaInicio: 1,                     // Página donde inicia esta marca
        totalPaginas: 25,        
        pdfUrl: "/catalogos/HermexCatalogo.pdf", // PDF para descarga
        caracteristicas: ["Seguridad máxima", "Diseño moderno"]
    },
    {
        id: 7,
        nombre: "KLINTEK",
        descripcion: "Artículos de limpieza para casa y oficina",
        logo: klintek,
        bg: "#009688",
        color: "#009688",
        catalogoPath: "/catalogos/klintek",
        paginaInicio: 1,
        totalPaginas: 5,
        pdfUrl: "/catalogos/KlintekCatalogo.pdf", // PDF para descarga
        caracteristicas: ["Limpieza profesional", "Casa y Oficina"]
    },
];


const logros = [
        { number: "100%", label: "Calidad Garantizada" },
        { number: "+8000", label: "Productos Disponibles" },
        { number: "7", label: "Marcas Líderes" },
    ];

function Marcas() {   
    const [showModal, setShowModal] = useState(false);
    const [selectedMarca, setSelectedMarca] = useState(null);
    const [hoveredCard, setHoveredCard] = useState(null);

    const truperMarca = marcas[0];
    const otrasMarcas = marcas.slice(1);

    const handleCardClick = (marca) => {
        setSelectedMarca(marca);
        setShowModal(true);
    };

    const handleClose = () => {
        setShowModal(false);
        setSelectedMarca(null);
    };

    return (
        <>   
            {/* Sección de Marcas */}
            <section className="marcas-section">
                {/* Fondo decorativo */}
                <div className="marcas-background">
                    <div className="bg-shape shape-1"></div>
                    <div className="bg-shape shape-2"></div>
                    <div className="bg-shape shape-3"></div>
                </div>

                <Container className="marcas-container">
                    {/* Header */}
                    <div className="marcas-header text-center">
                        <div className="section-badge-marcas">
                            <Award size={20} />
                            <span>Nuestras Marcas</span>
                        </div>
                        <h2 className="marcas-title">
                            Marcas <span className="text-highlight-marcas">Especializadas</span>
                        </h2>
                        <p className="marcas-subtitle">
                            Productos especializados por segmento para cubrir todas tus necesidades
                        </p> 
                        <div className="title-divider-marcas"></div>
                    </div>
                   
                    {/* Grid de Marcas */}
                    <Row className="g-4 marcas-grid">
                        {/* Tarjeta Principal - TRUPER */}
                        <Col xs={12} lg={6} className="d-flex">
                            <Card
                                className={`marca-card-principal ${hoveredCard === truperMarca.id ? 'hovered' : ''}`}
                                onClick={() => handleCardClick(truperMarca)}
                                onMouseEnter={() => setHoveredCard(truperMarca.id)}
                                onMouseLeave={() => setHoveredCard(null)}
                            >
                                {/* Badge Destacado */}
                                <div className="marca-badge-destacado">
                                    <Star size={16} fill="#ffffff" />
                                    <span>Marca Principal</span>
                                </div>

                                {/* Contenedor del logo con efecto */}
                                <div className="marca-logo-container-principal">
                                    <div 
                                        className="marca-logo-bg"
                                        style={{ backgroundColor: `${truperMarca.color}15` }}
                                    ></div>
                                    <Card.Img
                                        variant="top"
                                        src={truperMarca.logo}
                                        className="marca-logo-principal"
                                    />
                                </div>

                                <Card.Body className="marca-body-principal">
                                    {/* <div className="marca-icon-wrapper" style={{ color: truperMarca.color }}>
                                        {iconosPorMarca[truperMarca.id]}
                                    </div>
                                    
                                    <h3 className="marca-nombre-principal" style={{ color: truperMarca.color }}>
                                        {truperMarca.nombre}
                                    </h3> */}
                                    
                                    {/* <p className="marca-descripcion-principal">
                                        {truperMarca.descripcion}
                                    </p> */}

                                    {/* Características */}
                                    <div className="marca-caracteristicas">
                                        {truperMarca.caracteristicas.map((caract, idx) => (
                                            <div key={idx} className="caracteristica-item">
                                                <CheckCircle size={16} style={{ color: truperMarca.color }} />
                                                <span>{caract}</span>
                                            </div>
                                        ))}
                                    </div>

                                    <div className="marca-cta-button" style={{ backgroundColor: truperMarca.color }}>
                                        <span>Ver Catálogo</span>
                                        <ExternalLink size={18} />
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>

                        {/* Grid de Otras Marcas */}
                        <Col xs={12} lg={6}>
                            <Row className="g-3 h-100">
                                {otrasMarcas.map((marca, index) => (
                                    <Col xs={6} md={4} key={marca.id}>
                                        <Card
                                            className={`marca-card-secundaria ${hoveredCard === marca.id ? 'hovered' : ''}`}
                                            onClick={() => handleCardClick(marca)}
                                            onMouseEnter={() => setHoveredCard(marca.id)}
                                            onMouseLeave={() => setHoveredCard(null)}
                                            style={{ animationDelay: `${index * 0.1}s` }}
                                        >
                                            {/* Logo con efecto de color de fondo */}
                                            <div className="marca-logo-container-secundaria">
                                                <div 
                                                    className="marca-color-indicator"
                                                    style={{ backgroundColor: marca.color }}
                                                ></div>
                                                <Card.Img
                                                    variant="top"
                                                    src={marca.logo}
                                                    className="marca-logo-secundaria"
                                                />
                                            </div>

                                            <Card.Body className="marca-body-secundaria">
                                                {/* <div className="marca-icon-small" style={{ color: marca.color }}>
                                                    {iconosPorMarca[marca.id]}
                                                </div>
                                                
                                                <h4 className="marca-nombre-secundaria">
                                                    {marca.nombre}
                                                </h4>
                                                 */}
                                                {/* <p className="marca-descripcion-secundaria">
                                                    {marca.descripcion}
                                                </p> */}

                                                {/* Mini características */}
                                                <div className="marca-mini-tags">
                                                    {marca.caracteristicas.map((caract, idx) => (
                                                        <span 
                                                            key={idx} 
                                                            className="mini-tag"
                                                            style={{ 
                                                                backgroundColor: `${marca.color}15`,
                                                                color: marca.color
                                                            }}
                                                        >
                                                            {caract}
                                                        </span>
                                                    ))}
                                                </div>

                                                <div className="marca-hover-overlay" style={{ backgroundColor: marca.color }}></div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                ))}
                            </Row>
                        </Col>
                    </Row>
                    {/* Sección de Estadísticas */}
                    <div className="logros-section">
                    <Row className="g-4 text-center">
                        {logros.map((logro, index) => (
                            <Col xs={6} lg={4} key={index}>
                                <div 
                                    className="logro-item"
                                    style={{ animationDelay: `${index * 0.5}s` }}
                                >
                                    <div className="logro-number">{logro.number}</div>
                                    <div className="logro-label">{logro.label}</div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </div>
                </Container>
            </section>

            {/* Modal Mejorado */}
            <Modal 
                show={showModal} 
                onHide={handleClose} 
                size="xl"
                fullscreen={true}
                className="marcas-modal-flipbook"
            >
                {selectedMarca && (
                    <FlipbookViewer 
                        marca={selectedMarca}
                        onClose={handleClose}
                    />
                )}
            </Modal>
        </>
    );
}

export default Marcas;